import { useUnit } from 'effector-react';
import { Trash2 } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { WalletWithAccountId } from 'shared/api';
import { ConfirmModalProps, createConfirmModal, ModalFormActionIconProps } from 'shared/ui';
import { DeleteWalletModel } from '../../model';

export const createDeleteWalletModal = (model: DeleteWalletModel) => {
	const ConfirmModal = createConfirmModal(model);

	const DeleteWalletModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [wallet] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('delete-wallet.title')}
				cancelButtonProps={{
					children: t('delete-wallet.cancel'),
				}}
				submitButtonProps={{
					children: t('delete-wallet.delete'),
					variant: 'destructive',
				}}
				{...props}
			>
				{t('delete-wallet.description', { name: wallet?.currency })}
			</ConfirmModal>
		);
	});

	const DeleteWalletModalActionIcon = forwardRef<
		HTMLButtonElement,
		ModalFormActionIconProps<WalletWithAccountId>
	>(({ modalData, ...props }, ref) => {
		const viewerAccountId = useUnit(viewerModel.$accountId);

		return (
			<ConfirmModal.ActionIcon
				ref={ref}
				data-test-id='delete-wallet-action-icon'
				variant='ghost-destructive'
				disabled={viewerAccountId === modalData.accountId || modalData.balance !== 0}
				modalData={modalData}
				{...props}
			>
				<Trash2 />
			</ConfirmModal.ActionIcon>
		);
	});

	return Object.assign(DeleteWalletModal, {
		ActionIcon: DeleteWalletModalActionIcon,
	});
};
